import { BaseWebComponent } from "./webcomponent-base";

export class SidebarItemWebComponent extends BaseWebComponent {
    static webComponentName = "wc-sidebar-item";
    static observedAttributes = [
        // List of attributes to observe for changes
        "active",
        "href",
        "icon",
        "caption"
    ];
    get href(): string {
        if (this.hasAttribute('post')) return "";
        return this.getAttribute('href') || "#";
    }
    get action(): string {
        return this.getAttribute('action') || "";
    }
    private subItemsElements!: HTMLElement[] | null;
    private subItemsHTML: string = '';
    protected hasSubItems: boolean = false;
    get icon(): string {
        return this.getAttribute('icon') || "";
    }
    get caption(): string {
        return this.getAttribute('caption') || "";
    }
    get linkClass(): string {
        return this.getAttribute('link-class') || "";
    }
    get active(): boolean {
        return location.pathname.endsWith(this.href) || this.hasAttribute('active');
    }
    set active(value: boolean) {
        if (value) {
            this.setAttribute('active', '');
        } else {
            this.removeAttribute('active');
        }
    }
    // Mostra i subitems se presenti
    get show(): boolean {
        return this.hasSubItems && this.hasAttribute('show') && this.getAttribute('show') !== 'false';
    }
    constructor() {
        super();
        this.init();
    }
    protected init(): void {
        this.subItemsElements = Array.from(this.querySelectorAll('wc-sidebar-subitem'));
        if (this.subItemsElements.length > 0) {
            this.hasSubItems = true;
            this.subItemsHTML = this.subItemsElements.map(el => el.outerHTML).join('');
            this.innerHTML = '';
            this.subItemsElements = null; // Clear reference to sub-items after extracting HTML
        }
        this.classList.add('loaded');
        this.on('click', 'a[data-action]', (event) => {
            event.preventDefault();
            const action = (event.target as HTMLElement).getAttribute('data-action');
            if (action) {
                document.dispatchEvent(new CustomEvent('invoke-action', { detail: { action, target: (event.target as HTMLElement) } }));
            }
        });
    }
    setupTooltips() {
        // Setup Bootstrap tooltips
        const tooltipTriggerList = [].slice.call(this.querySelectorAll('[data-wc-tooltip]'));
        tooltipTriggerList.forEach(function (tooltipTriggerEl: HTMLElement) {
            if (window.bootstrap && window.bootstrap.Tooltip) {
                const title = tooltipTriggerEl.getAttribute('data-wc-tooltip') || '';
                window.bootstrap.Tooltip.getOrCreateInstance(tooltipTriggerEl, {
                    title,
                    trigger: 'hover',
                    placement: 'right'
                });
            } else {
                console.warn('Bootstrap Tooltip is not available.');
            }
        });
    }
    protected onConnected(): void {
        this.customRender();
    }
    protected onAttributeChange(name: string, oldValue: string, newValue: string): void {
        this.customRender(true);
    }
    renderWithSubItems(): void {
        const _id = this.createRandomId();
        const lines = [];
        lines.push(`<li class="sidebar-nav-item has-submenu">`);
        lines.push(`<button type="button" 
            class="sidebar-nav-link ${this.active ? 'active' : ''} ${this.linkClass}"
            aria-controls="${_id}" 
            data-bs-toggle="collapse"
            data-bs-target="#${_id}" 
            data-wc-tooltip="${this.caption}">`);
        if (this.icon) {
            lines.push(`<i class="sidebar-nav-icon bi bi-${this.icon}"></i>`);
        }
        lines.push(`<span class="sidebar-nav-text">${this.caption}</span>`);
        lines.push(`<i class="sidebar-nav-arrow bi bi-chevron-down"></i>`);
        lines.push(`</button>`);
        lines.push(`<div id="${_id}" class="collapse sidebar-submenu">`);
        lines.push(`<ul class="sidebar-nav">`);
        lines.push(this.subItemsHTML);
        lines.push(`</ul>`);
        lines.push(`</div>`);
        lines.push(`</li>`);
        this.innerHTML = lines.join('\n');
        // Initialize Bootstrap collapse
        const collapseElement = this.querySelector(`#${_id}`);
        const sidebarNavItem = this.querySelector('.sidebar-nav-item');
        if (collapseElement && window.bootstrap && window.bootstrap.Collapse) {
            const instance = window.bootstrap.Collapse.getOrCreateInstance(collapseElement, {
                toggle: false
            });
            collapseElement.addEventListener('shown.bs.collapse', () => {
                if (sidebarNavItem) {
                    sidebarNavItem.classList.add('shown');
                }
            });
            collapseElement.addEventListener('hidden.bs.collapse', () => {
                if (sidebarNavItem) {
                    sidebarNavItem.classList.remove('shown');
                }
            });
            if (this.show) {
                instance.show();
            }
            else {
                instance.hide();
            }
        } else {
            console.warn('Bootstrap Collapse is not available or collapse element not found.');
        }
    }
    private renderedOnce: boolean = false;
    protected customRender(force = false): void {
        if (this.renderedOnce && !force) {
            return;
        }
        this.renderedOnce = true;
        if (this.hasSubItems) {
            this.renderWithSubItems();
            this.setupTooltips();
            return;
        }
        else {
            const lines = [];
            lines.push(`<li class="sidebar-nav-item">`);
            lines.push(`<a  
                class="sidebar-nav-link ${this.active ? 'active' : ''} ${this.linkClass}" 
                data-wc-tooltip="${this.caption}" 
                ${this.action ? `data-action="${this.action}"` : ''}
                href="${this.href}">`);
            if (this.icon) {
                lines.push(`<i class="sidebar-nav-icon bi bi-${this.icon}"></i>`);
            }
            lines.push(`<span class="sidebar-nav-text">${this.caption}</span>`);
            lines.push(`</a>`);
            lines.push(`</li>`);
            this.innerHTML = lines.join('\n');
            this.setupTooltips();
        }
        // Render nothing, act as a transparent wrapper
    }
    render(): void {
        this.customRender(false);
    }
}

